import { getTiBfromGiB } from '../../lib/helpers';
import { GIB_TO_TIB_THRESHOLD } from './constants';

/**
 * Converts a GiB value to TiB when it meets or exceeds the threshold.
 */
export const formatStorageSize = (gib, threshold = GIB_TO_TIB_THRESHOLD) => {
    if (gib >= threshold) {
        return { value: getTiBfromGiB(gib), unit: 'TiB' };
    }
    return { value: gib, unit: 'GiB' };
};

/**
 * Computes VMs ready for migration
 */
export const calcReadyForMigration = (ready) => {
    if (!ready) return 0;
    if ('linux' in ready && 'windows' in ready) {
        return (ready.linux ?? 0) + (ready.windows ?? 0);
    }
    return (ready.linuxReady ?? 0) + (ready.windowsReady ?? 0);
};

/**
 * Returns a percentage number of count relative to total.
 * Uses Math.floor; values between 0 and 1 are shown as 1%.
 * Values between 99 and 100 are shown as 99%.
 */
export const calculatePercentage = (count, total) => {
    const n = Number(count);
    if (!n || total <= 0) return 0;
    const pct = (n / total) * 100;
    return pct > 0 && pct < 1 ? 1 : Math.floor(pct);
};

/**
 * Returns a percentage string.
 */
export const formatPercent = (pct) => {
    return `${pct}%`;
};

/**
 * Returns a state ('ready' | 'danger' | 'warning') based on oversized/undersized trend direction.
 * Note: oversized/undersized going 'down' is good, which is the opposite of the primary trend logic
 */
export const oversizedUndersizedState = (trendDirection) => {
    if (trendDirection === 'down') {
        return 'ready';
    }
    if (trendDirection === 'up') {
        return 'danger';
    }
    if (trendDirection === undefined) {
        return 'warning';
    }
};

/**
 * Returns a state ('ready' | 'danger' | 'warning') based on the primary trend direction.
 */
export const primaryTrendState = (trendDirection) => {
    if (trendDirection === 'up') {
        return 'ready';
    }
    if (trendDirection === 'down') {
        return 'danger';
    }
    if (trendDirection === undefined) {
        return 'warning';
    }
};

/**
 * Computes storage reduction opportunities: non-ready VMs that are not undersized by storage.
 */
export const calcStorageReductionOpportunities = (totalInventory, totalReady, undersizedByStorage) =>
    Math.max(0, totalInventory - totalReady - undersizedByStorage);

/**
 * Derives a primary card trend from net summation of oversized/undersized trend values.
 */
export const deriveNetTrend = (oversized, undersized) => {
    const net = oversized + undersized;
    if (net > 0) return 'down';
    if (net < 0) return 'up';
    return undefined;
};

/**
 * Derives a single row trend from a trend value.
 */
export const deriveRowTrend = (trendValue) => {
    if (trendValue > 0) return 'up';
    if (trendValue < 0) return 'down';
    return undefined;
};
